import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import { Calf } from '@/types.gql';

import { useCalfEntryContext } from './useCalfEntryContext';

type CalfEntryLoggedProps = {
  className?: string;
  handleCalfEntryDeleteAction: (calf: Calf) => void;
};

export const CalfEntryLogged = ({
  className,
  handleCalfEntryDeleteAction,
}: CalfEntryLoggedProps) => {
  const { calves } = useCalfEntryContext();

  const CalfEntryAction = (calf: Calf) => {
    return (
      <Button
        text
        icon="pi pi-trash"
        onClick={() => handleCalfEntryDeleteAction(calf)}
      />
    );
  };

  return (
    <DataTable
      className={`calf-entry-logged glass ${className}`.trim()}
      value={calves}
    >
      <Column field="registry" body={CalfEntryAction}></Column>
      <Column field="penName" header="Barn/Pen"></Column>
      <Column field="tag" header="Calf ID"></Column>
      <Column field="registry" header="RFID"></Column>
      <Column field="breedName" header="Breed"></Column>
    </DataTable>
  );
};
